"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Boolean = Boolean;

var _react = _interopRequireWildcard(require("react"));

var _radios = _interopRequireDefault(require("govuk-frontend/govuk/components/radios/radios"));

var _checkboxes = _interopRequireDefault(require("govuk-frontend/govuk/components/checkboxes/checkboxes"));

var _govuk = require("../govuk");

var _omitKey = _interopRequireDefault(require("./omitKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Boolean(props) {
  var className = props.className,
      errorMessage = props.errorMessage,
      fieldset = props.fieldset,
      formGroup = props.formGroup,
      hint = props.hint,
      idPrefix = props.idPrefix,
      items = props.items,
      controlType = props.controlType,
      name = props.name,
      onChange = props.onChange,
      onBlur = props.onBlur,
      describedByProp = props['aria-describedby'],
      attributes = _objectWithoutProperties(props, ["className", "errorMessage", "fieldset", "formGroup", "hint", "idPrefix", "items", "controlType", "name", "onChange", "onBlur", "aria-describedby"]);

  var controlRef = (0, _react.useRef)();
  var idPrefixValue = idPrefix || name;
  var describedBy = describedByProp || '';

  if (fieldset === null || fieldset === void 0 ? void 0 : fieldset['aria-describedby']) {
    describedBy = fieldset['aria-describedby'];
  }

  var hintComponent;
  var errorMessageComponent;
  (0, _react.useEffect)(function () {
    switch (controlType) {
      case 'radios':
        new _radios["default"](controlRef.current).init();
        break;

      case 'checkboxes':
        new _checkboxes["default"](controlRef.current).init();
        break;

      default:
    }
  }, [controlRef, controlType]);

  if (hint) {
    var hintId = "".concat(idPrefixValue, "-hint");
    describedBy += " ".concat(hintId);
    hintComponent = /*#__PURE__*/_react["default"].createElement(_govuk.Hint, _extends({}, hint, {
      id: hintId
    }));
  } // Find out if we have any conditional items


  var isConditional = !!items.find(function (item) {
    var _item$conditional;

    return (_item$conditional = item.conditional) === null || _item$conditional === void 0 ? void 0 : _item$conditional.children;
  });
  var hasFieldset = !!fieldset;

  if (errorMessage) {
    var errorId = "".concat(idPrefixValue, "-error");
    describedBy += " ".concat(errorId);
    errorMessageComponent = /*#__PURE__*/_react["default"].createElement(_govuk.ErrorMessage, _extends({}, errorMessage, {
      id: errorId
    }));
  }

  var innerHtml = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hintComponent, errorMessageComponent, /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "govuk-".concat(controlType, " ").concat(controlType === 'radios' && isConditional ? "govuk-".concat(controlType, "--conditional") : '', " ").concat(className || '')
  }, attributes, {
    ref: controlRef,
    "data-module": isConditional ? "govuk-".concat(controlType) : null
  }), items.map(function (item, index) {
    var id = item.id,
        children = item.children,
        itemHint = item.hint,
        itemConditional = item.conditional,
        label = item.label,
        itemAttributes = _objectWithoutProperties(item, ["id", "children", "hint", "conditional", "label"]);

    var idSuffix = "-".concat(index + 1);
    var idValue = id || "".concat(idPrefixValue).concat(index === 0 ? '' : idSuffix);
    var nameValue = item.name ? item.name : name;
    var conditionalId = (itemConditional === null || itemConditional === void 0 ? void 0 : itemConditional.children) ? "conditional-".concat(idValue) : null;
    var itemHintId = "".concat(idValue, "-item-hint");
    var itemDescribedBy = '';

    if (!hasFieldset) {
      itemDescribedBy = describedBy;
    }

    if (itemHint) {
      itemDescribedBy += " ".concat(itemHintId);
    }

    if (item.divider) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: item.reactListKey || index,
        className: "govuk-".concat(controlType, "__divider")
      }, item.divider);
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: item.reactListKey || index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "govuk-".concat(controlType, "__item")
    }, /*#__PURE__*/_react["default"].createElement("input", _extends({
      className: "govuk-".concat(controlType, "__input"),
      id: idValue,
      name: nameValue,
      type: controlType === 'radios' ? 'radio' : 'checkbox',
      "data-aria-controls": conditionalId,
      "aria-describedby": itemDescribedBy || null,
      onChange: onChange,
      onBlur: onBlur
    }, itemAttributes)), /*#__PURE__*/_react["default"].createElement(_govuk.Label, _objectSpread(_objectSpread({}, label), {}, {
      className: "govuk-".concat(controlType, "__label ").concat((label === null || label === void 0 ? void 0 : label.className) || ''),
      htmlFor: idValue,
      isPageHeading: false
    }), children), itemHint ? /*#__PURE__*/_react["default"].createElement(_govuk.Hint, _extends({}, _objectSpread(_objectSpread({}, itemHint), {}, {
      className: "govuk-".concat(controlType, "__hint ").concat(itemHint.className || '')
    }), {
      id: itemHintId
    })) : ''), (itemConditional === null || itemConditional === void 0 ? void 0 : itemConditional.children) ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "govuk-".concat(controlType, "__conditional ").concat(item.checked ? '' : "govuk-".concat(controlType, "__conditional--hidden")),
      id: conditionalId
    }, itemConditional.children) : '');
  })));

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "govuk-form-group".concat(errorMessage ? ' govuk-form-group--error' : '', " ").concat((formGroup === null || formGroup === void 0 ? void 0 : formGroup.className) || '')
  }, hasFieldset ? /*#__PURE__*/_react["default"].createElement(_govuk.Fieldset, _extends({}, (0, _omitKey["default"])(fieldset, 'role'), {
    "aria-describedby": describedBy.trim() || null
  }), innerHtml) : innerHtml);
}